import componentComposition from 'lib/trait/composition/component'

const descriptor = 'G.Field'

export default componentComposition(descriptor)
